document.addEventListener('DOMContentLoaded', function() {
  // Lightbox-Container erstellen
  const overlay = document.createElement('div');
  overlay.id = 'pdf-lightbox';
  overlay.innerHTML = `
    <div class="pdf-lightbox-content">
      <button class="pdf-lightbox-close" aria-label="Schließen">&times;</button>
      <iframe class="pdf-lightbox-iframe"></iframe>
    </div>
  `;
  document.body.appendChild(overlay);

  // Styles
  const style = document.createElement('style');
  style.textContent = `
    #pdf-lightbox {
      display: none;
      position: fixed;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(0,0,0,0.85);
      z-index: 99999;
      padding: 20px;
      box-sizing: border-box;
    }
    #pdf-lightbox.active { 
      display: flex; 
      align-items: center; 
      justify-content: center; 
    }
    .pdf-lightbox-content {
      position: relative;
      width: 100%;
      max-width: 900px;
      height: 90vh;
      background: #fff;
      border-radius: 8px;
      overflow: hidden;
    }
    .pdf-lightbox-close {
      position: absolute;
      top: 10px;
      right: 10px;
      width: 44px;
      height: 44px;
      background: #e53935;
      color: #fff;
      border: none;
      border-radius: 50%;
      font-size: 28px;
      font-weight: bold;
      cursor: pointer;
      z-index: 100000;
      line-height: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      box-shadow: 0 2px 10px rgba(0,0,0,0.3);
    }
    .pdf-lightbox-close:hover { background: #c62828; }
    .pdf-lightbox-iframe {
      width: 100%;
      height: 100%;
      border: none;
    }
  `;
  document.head.appendChild(style);

  const iframe = overlay.querySelector('.pdf-lightbox-iframe');
  const closeBtn = overlay.querySelector('.pdf-lightbox-close');

  const closeLightbox = function() {
    overlay.classList.remove('active');
    iframe.src = '';
    document.body.style.overflow = '';
  };

  closeBtn.addEventListener('click', closeLightbox);
  
  overlay.addEventListener('click', function(e) {
    if (e.target === overlay) closeLightbox();
  });
  
  document.addEventListener('keydown', function(e) {
    if (e.key === 'Escape') closeLightbox();
  });

  // Event Delegation auf document - fängt ALLE Klicks auf PDF-Links ab
  document.addEventListener('click', function(e) {
    const link = e.target.closest('a[href*=".pdf"]');
    if (link && link.href.includes('cdn.shopify.com')) {
      e.preventDefault();
      e.stopPropagation();
      iframe.src = link.href;
      overlay.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }, true);
});